function applyQuantity(el) {
  document.querySelectorAll('.Radio_quanity').forEach((sib) => {
    sib.classList.remove('active');
  });

  el.classList.add('active');

  const qtyClass = [...el.classList].find(cls => cls.startsWith('qty-'));
  if (!qtyClass) return;

  const qty = parseInt(qtyClass.split('-').pop(), 10);
  const qtyInput = el.closest('.product-information__grid')
                     .querySelector('input[type=number]');

  if (!qtyInput) return;

  qtyInput.value = qty;
  qtyInput.dispatchEvent(new Event('input', { bubbles: true }));
}

document.querySelectorAll('.Radio_quanity').forEach((el) => {
  el.addEventListener('click', function () {
    applyQuantity(this);
  });
});

document.addEventListener('DOMContentLoaded', () => {
  const defaultActive = document.querySelector('.Radio_quanity.active');
  if (defaultActive) {
    applyQuantity(defaultActive);
  }
});
